import { render, staticRenderFns } from "./StudyRecordTerms.vue?vue&type=template&id=431af7ec"
import script from "./StudyRecordTerms.vue?vue&type=script&lang=js"
export * from "./StudyRecordTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports